import { get, post } from "../api/apiClient";
import { authHeader } from "../api/authHeader";
import UpdatePriorityTargetRequest from "../form/request/UpdatePriorityTargetRequest";

const API_PREFIX = "/planningSheet";

export const init =async request => {
  console.log("request", request);
  var requestUrl = "?termId=" + request.termId + "&listId=" + request.listId;
  return await get(`${API_PREFIX}/${requestUrl}`, authHeader()).then(response => {
    console.log("response", response);
    return response.data;
  });
};



export const update = request => {
  console.log("request", request);
  return post(`${API_PREFIX}/update`, new UpdatePriorityTargetRequest(request), authHeader()).then(response => {
    console.log("response", response);
    return response.data;
  });
};

export const checkPriorityTarget = request => {
  console.log("request", request);
  return post(`${API_PREFIX}/checkPriorityTarget`, request, authHeader()).then(response => {
    console.log("response", response);
    return response.data;
  });
}
